import React, { useState } from 'react'
// @ts-ignore
import Fade from 'react-reveal/Fade'
import { Element } from 'react-scroll'
import { PointTitle } from '../atoms/pointtitle'
import { FullImageCard } from '../molecules/full_image_card'

export const PointSystemView = () => {

  const cards: { imageName: string, title: string, description: string }[] = [
    { imageName: "point-system-1.jpg", title: "素材", description: "PETGの弾性を利用し、断続的に力を加えることで歯を動かします。" },
    { imageName: "point-system-2.jpg", title: "治療計画作成支援", description: "矯正専門医はボルトン分析やセファロ分析を行い、歯の動きを全て数値化・具体化し治療計画作成の支援をいたします。" },
    { imageName: "point-system-3.jpg", title: "ソフトウェア", description: "特許を取得した歯科矯正ソフトウェアは、使いやすさと設計の正確さを保証し、治療前に最適な3D治療計画と最終結果を確認できます。" },
    { imageName: "point-system-4.jpg", title: "適応症例", description: "叢生、上顎前突、下顎前突、開咬、正中離開、切端咬合の症例に対しての治療が可能です。" },
    { imageName: "point-system-5.jpg", title: "製造工程", description: "製造工程において、厳密な運用要件とルールを策定し、高品質を保証しております。各アライナーは5回以上の検査を実施しております。" },
    { imageName: "point-system-6.jpg", title: "品質保証", description: "アライナーはFDAの認証を受けているPETGを使用し、他にもCE、ARTG、NMPAの品質管理基準の認証を取得しております。" },
  ]

  const [openIndex, setOpenIndex] = useState<number | null>(null)
  return (
    <section className="content">
      <Element name="page-system" className="content--standard pointsystemview">
        <PointTitle>システムの特徴</PointTitle>
        <section className="pointsystemview--listArea">
          {cards.map((card, index) => (
            <FullImageCard
              key={index}
              index={index}
              openIndex={openIndex}
              imageName={card.imageName}
              title={card.title}
              description={card.description}
              onClick={() => setOpenIndex(index === openIndex ? null : index)}
            />
          ))}
        </section>
      </Element>
    </section>
  )
}